import React, { useState , useEffect} from 'react';

import Movieinfo from "../movie/movieinfo.js";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';



export default function Swipe(props) {
  const [slideshow, setHeaderSlideShow] = useState("");
  const [ movieData , setMovieData] = useState('');
  const [ modalOpen, setModalOpen] = useState(false);
  

  useEffect(() => {
    if(props.data[0]) setHeaderSlideShow(props.data[0]);  
  }, 
  [slideshow , props.data[0]])

  const openModal = (data) => {setModalOpen(true); setMovieData(data); };
  
  function handleChange(modalChange) { setModalOpen(modalChange); }

  return (
    <div>
    <Movieinfo key={movieData.title}  modalvisible = {modalOpen} data = {movieData} datafeelings = {props.datafeelings} onChange={handleChange} />
    <Swiper
    spaceBetween={0}
    slidesPerView={3}
    navigation
    initialSlide = {1}
    loop={ true }
    effect={  "slide" }
    longSwipes={ false }
    centeredSlides={ true }
    keyboard={ true }
    simulateTouch={ true }
    slideToClickedSlide={ true }
    parallax={ true }
    speed={ 600 }
    touchRatio={ 1 }
    pagination={{ clickable: true }}
    scrollbar={{ draggable: true }}
  >
  {
    slideshow && slideshow.map(data=>{
      return(
      <SwiperSlide key={data.title}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-8">
            <h2>{data.title}</h2>
            <p>{data.description}</p>
            </div>
            <div className="col-xl-4 swiper-no-swiping">
              <a onClick={(e) => { e.preventDefault(); openModal(data); }}>Details</a>
              <a href={data.movie_link}>Imdb</a>
            </div>
          </div>
        </div>
        <img alt={data.title} src={data.movie_image} />  
        <div className="shadowover"></div>  
      </SwiperSlide>
      )
      })
    }
    </Swiper>
    </div>
  )
}


         
